<template>
  <keep-alive>
    <top-navbar :currentRoute="$route" :filter="false"></top-navbar>
  </keep-alive>

  <transition name="fade">
    <section v-if="!isReady">
      <div class="container-loading">
        <span class="loader loader-default loader-dark"></span>
      </div>
    </section>
  </transition>

  <transition name="fade">
    <div v-if="!isEmpty(orderError)" class="error-message mt-10">
      {{ orderError }}
    </div>
    <div v-else-if="isReady">
      <section class="container-content">

      <!-- Блок 6.3.3.1-А.  Детальная информация по блоку в разделе 6.3.3.3. -->
      <div class="accordion-block-header">
        <!-- Номер Заказа. При создании не заполняется. Заполняется при обмене с 1С из 1С -->
        <div v-show="isOrderNum" class="container-acc-header">
          № 12345
        </div>
        <!-- Текущая дата -->
        <div class="container-acc-header">
          Дата создания: 
          <span class="order-color-date">{{ objectNewOrder.created }}</span>
        </div>
        <!-- При создании заказа Черновик -->
        <div class="container-acc-header">
          Статус: 
          <span class="draft">{{ objectNewOrder.status }}</span>
        </div>
        <!-- устанавливается после сохранения из поля Желаемая дата доставки -->
        <!-- <div v-show="!isEmpty(objectNewOrder.shipmentDate)" class="container-acc-header">
          Дата отгрузки: 
          <span class="order-color-date">{{ objectNewOrder.shipmentDate }}</span>
        </div> -->
      </div>

      <!-- Блок для вывода уведомлений по Заказу. -->
      <div class="error-message" v-show="errorText != ''">
        <span>{{ errorText }}</span>
      </div>
      <div class="success-message" v-show="successText != ''">
        <span>{{ successText }}</span>
      </div>

      <div class="accordion-block">
        <div class="accordion-block-item">
          <!-- Блок с общими данными по Заказу. -->
          <div class="accordion-block-content">
            <div class="row">
              <div class="col-12 col-lg-6">
                <!-- Заполняется автоматически по карточке пользователя -->
                <div class="container-center">
                  <div class="group-label-input">
                    <label>Контрагент</label>
                    <input type="text" v-model="objectNewOrder.contrAgent.title" readonly>
                  </div>
                </div>

                <div class="container-center">
                  <div class="group-label-input">
                    <label>Тип продукции</label>
                    <select v-model="objectNewOrder.division">
                      <option v-for="(type) in objectOrderDraft.division" :key="type" :value="type">{{type}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-6">
                <!-- Ручной ввод -->
                <div class="container-center">
                  <div class="group-label-input">
                    <label>Номер заказа клиента</label>
                    <input type="text" v-model="objectNewOrder.orderNumberClient">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <accordion class="accordion-block" :openBlock="true" title="Информация по доставке">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="container-center">
              <div class="group-label-input">
                <!-- если самовывоз - все остальные поля блока недоступны для редактирования -->
                <label>Способ доставки</label>
                <select v-model="objectNewOrder.shipmentMethod">
                  <option v-for="(method) in objectOrderDraft.deliveryMethods" :key="method" :value="method">{{method}}</option>
                </select>
              </div>
            </div>
            <div class="container-center">
              <div class="group-label-input">
                <label>Регион</label>
                <select 
                  v-model="objectNewOrder.region_id"
                  :class="{'disableField': isEmpty(objectNewOrder.shipmentMethod)}"
                  v-bind:disabled="isEmpty(objectNewOrder.shipmentMethod)"
                >
                  <option v-for="(region, index) in objectOrderDraft.regions" :key="index" :value="region.id">{{region.name}}</option>
                </select>
              </div>
            </div>

            <div class="container-center">
              <div class="group-label-input">
                <label>Адрес доставки</label>  

                <shipment-address-field
                  :addressStr = "objectNewOrder.shipmentAddress"
                  :shipmentMethod = "objectNewOrder.shipmentMethod"
                  :incorrectAddress = "incorrectAddress"
                  :haveNewAddress = "haveNewAddress"
                  :selectedAddress = "selectedAddress"
                  @addShipmentAddress = "addShipmentAddress"
                  @showFormAddAddressMethod = "showFormAddAddressMethod"
                  @editShipmentAddress = "editShipmentAddress"
                  @haveNewAddressFalse = "haveNewAddressFalse"
                >
                </shipment-address-field>

                
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6">

            <div class="container-center">
              <div class="group-label-input">
                <label>Грузополучатель, КПП</label>
                <input type="text" v-model="objectNewOrder.consignee">
              </div>
            </div>

            <div class="container-center">
              <div class="group-label-input">
                <label>ИНН</label>
                <input type="text" :class="{'error-field': incorrectInn}" v-mask="'############'" v-model="objectNewOrder.inn" placeholder="юр. лицо - 10 цифр, ИП - 12 цифр">
              </div>
            </div>

          </div>
          <div class="col-12">
            <div class="container-center">
              <div class="group-label-input w-100">
                <label>Дополнительная информация</label>
                <textarea 
                  v-model="objectNewOrder.addInformation"
                  name="text" 
                ></textarea>  
              </div>
            </div>
          </div>
        </div>
      </accordion>

      <div class="container-for-load-items">
        <div v-show="loadingItems" class="loading-items-block">
          <span class="loader loader-default loader-light"></span>
        </div>
        <!-- Машины с товарами-->
        <div v-for="(car) in objectNewOrder.cars" :key="car.carId" :value="car">
          <accordion 
            class="accordion-block" 
            :openBlock="true" 
            :weight="formatNumber(car.orderWeight)" 
            :load="car.occupancyRate" 
            :summ="formatNumber(car.summ)" 
            :title="objectNewOrder.shipmentMethod == 'Доставка' ? 'Товары. Машина №' + car.carId : 'Товары'" 
            type="goods"
            :carId="car.carId"
            @delCar="delCar"
          >
            <div class="col-12 col-lg-6">
              <div class="group-label-input start-content">
                <label>Желаемая дата отгрузки</label>
                <DatePicker 
                  v-model="car.shipmentDate" 
                  class="customDate"
                  :disabled-dates="minDate"
                  language="ru"
                  :weekStartsOn="1"
                  :clearable="true"
                  @input="updateShipmentDate(car)"
                />
              </div>
            </div>

            <table class="order-table">
              <tr>
                <!-- При клике на кнопку должно происходить удаление из блока Д товаров, 
                для которых выбран чек-бокс Д6 -->
                <th rowspan="2" class="pointer" style="width: 29px;" title="Удалить выбранные товары" @click="delSelectedItems(car.carId)">
                  <img src="@/assets/img/del.svg">
                </th>
                <th rowspan="2">Наименование/Артикул</th>
                <!-- Источник цены для товара. При клике должен раскрываться список доступных видов 
                цены для данного пользователя для данного товара. 
                В верхней части раскрывающегося списка должно быть поле для ввода. 
                Значения списка должны фильтроваться по тексту, указанному в поле ввода. 
                Пример реализации:  СМОТРИМ ТЗ, ТАМ СКРИН СТР 33-->
                <th rowspan="2">Вид цены</th>
                <th rowspan="2">Цена с НДС</th>
                <th colspan="4" class="text-center">Количество </th>
                <th rowspan="2">Общая сумма</th>
              </tr>
              <tr>
                <th>ед</th>
                <th>м2</th>
                <th>м3</th>
                <th>кг</th>
              </tr>
              <tr v-for="item in car.items" :key="item.rowId" :value="item.rowId">
                <!-- Чек-бокс. При клике на кнопку Д5 должно происходить удаление из блока Д товаров, 
                для которых выбран чек-бокс Д5. -->
                <td>
                  <input 
                  type="checkbox" 
                  :value="item.rowId"
                  :checked="isSelectedRemoveItem(car.carId, item.rowId)"
                  @change="handleItemsRemoveChange(car.carId, item.rowId)"
                  >
                </td>
                <td>
                  <span class="tab-text-name">{{ item.name }}</span><br>
                  <span class="tab-text-art">{{ item.sku }}</span>
                </td>
                <td class="relative">
                  <span 
                    class="price-type vid-ps btn-default" 
                    :class="getBgPriceType(item)" 
                    @click="togglePriceTypes(car, item)"
                  >
                    <span v-if="isEmpty(item.selectedPriceType)" class="center-content">
                      Выберите тип
                      <mdicon 
                        name="chevron-right" 
                        width="18" 
                        height="18" 
                      />
                    </span>
                    <span v-else class="center-content">
                      {{ item.selectedPriceType.title }}
                      <mdicon 
                        name="chevron-right" 
                        width="18" 
                        height="18" 
                      />
                    </span>
                  </span>

                  <div class="container-price-types" v-show="showPriceTypes == (car.carId + '-' + item.rowId)">
                    <span class="container-icon" title="Закрыть" @click="closeModal()">
                      <mdicon name="close" width="16" height="16"/> 
                    </span>
                    <div v-for="(type) in item.priceTypes" 
                      :key="type.title" 
                      :value="type.title" 
                      class="container-price-types-item" 
                      @click="getPriceType(type, item)"
                    >
                      {{ type.title }}
                    </div>
                  </div>

                </td>
                <td>{{ formatNumber(item.selectedPriceType.price) }}</td>

                <td class="td-edit-field">
                  <input v-if="showEditQuantity == (car.carId + '-' + item.rowId)" class="quantity-field" type="number" v-model="item.quantity">
                  <span v-else>{{ formatNumber(item.quantity) }}</span>
                  <span v-if="showEditQuantity == (car.carId + '-' + item.rowId)" class="td-edit-field-icon" @click="calculateQuantity(item, car.carId)">
                    <mdicon name="check-bold" width="16" height="16" /> 
                  </span>
                  <span v-else class="td-edit-field-icon" @click="getEditQuantity(car.carId, item.rowId)">
                    <mdicon name="pencil" width="16" height="16"/> 
                  </span>
                </td>

                <td class="td-edit-field">
                  <input v-if="showEditArea == (car.carId + '-' + item.rowId)" class="quantity-field" type="number" v-model="item.area">
                  <span v-else>{{ formatNumber(item.area) }}</span>
                  <span v-if="showEditArea == (car.carId + '-' + item.rowId)" class="td-edit-field-icon" @click="calculateArea(item, car.carId)">
                    <mdicon name="check-bold" width="16" height="16" /> 
                  </span>
                  <span v-else class="td-edit-field-icon" @click="getEditArea(car.carId, item.rowId)">
                    <mdicon name="pencil" width="16" height="16"/> 
                  </span>
                </td>

                <td class="td-edit-field">
                  <input v-if="showEditVolume == (car.carId + '-' + item.rowId)" class="quantity-field" type="number" v-model="item.volume">
                  <span v-else>{{ formatNumber(item.volume) }}</span>
                  <span v-if="showEditVolume == (car.carId + '-' + item.rowId)" class="td-edit-field-icon" @click="calculateVolume(item, car.carId)">
                    <mdicon name="check-bold" width="16" height="16" /> 
                  </span>
                  <span v-else class="td-edit-field-icon" @click="getEditVolume(car.carId, item.rowId)">
                    <mdicon name="pencil" width="16" height="16"/> 
                  </span>
                </td>

                <td>{{ formatNumber(item.weight) }}</td>
                <td class="text-right">{{ formatNumber(getItogItemSumm(item)) }}</td>
              </tr>
            </table>
            <span 
              class="btn-add vid-ps btn-default"
              @click="getOrderItems(car.carId)"
              v-show="(originItemsByCarId.get(String(car.carId))?.length || 0) > 0"
            >
              <mdicon 
                name="plus" 
                width="18" 
                height="18" 
              />
              Добавить товар
            </span>

            <div 
              v-if="objectNewOrder.region_id && objectNewOrder.shipmentMethod != 'Самовывоз'" 
              class="col-12 related-orders"
              :class="[this.isEmpty(car.shipmentDate) || car.items.length < 1 || car.occupancyRate <= 0 || car.occupancyRate >= 100 ? 'disable-block' : '']"
            >
              <label>Связанные заказы</label>
              <div class="group-label-input start-content">
                <!-- {{ car.relatedOrders }}
                {{ car.relatedOrders }}
                {{ clearSelected }} -->
                <select-component 
                  :selected = "car.relatedOrders"
                  :options = "allRelatedOrders.filter( order => order.shipmentDate == formatDate(car.shipmentDate) && (order.carId == car.carId || order.carId == 0))"
                  selectedType = "exactly"
                  defaultFields = "false"
                  typeSelector = "relatedOrders"
                  :clearSelected = "clearSelected"
                  @selectedElements="(selected) => selectedRelatedOrders(car.carId, selected)"
                ></select-component>

              </div>
            </div>

          </accordion>
        </div>

        <div v-if="showModalAddItems" class="modal-vue modal-add-items" :class="{ 'fade-in': showModalAddItems, 'fade-out': !showModalAddItems }">
          <span class="container-icon" title="Закрыть" @click="closeModal('addItems')">
            <mdicon name="close" width="22" height="22"/> 
          </span>
            
          <div class="container-loading-modal" v-if="!flagGetItems">
            <span class="loader loader-default loader-dark"></span>
          </div>
          <div v-else>
            <p class="modal-title">Выберите товары</p>
            <div class="group-label-input">
              <input type="text" v-model="textForSearchItemsAdd" placeholder="Введите артикул или название товара ">
              <span v-show="searchingOrderAllItems" class="load-field-icon loader loader-for-field loader-dark-small"></span>
            </div>
            <div v-if="(originItemsByCarId.get(String(currentCarId))?.length || 0) > 0">
              <div 
                class="block-cb block-field-hover"
                @click="selectOrderAllItems(currentCarId)"
              >
                <input 
                  type="checkbox" 
                  :value="currentCarId"
                  v-model="addOrderAllItems"
                >
                <div class="blockAddFields">
                  <span class="tab-text-art">Отметить все</span>
                </div>
              </div>
              <div class="container-add-items">
                <div 
                  class="block-cb block-field-hover"
                  v-for="item in (itemsByCarId.get(String(currentCarId)) ?? [])"
                  :key="item.id"
                  @click="addItem(item.id, selectedItems)"
                  :class="[selectedItemsByCarId.includes(item.id) ? 'active-field' : '']"
                >
                  <input 
                    type="checkbox" 
                    :value="item.id"
                    v-model="selectedItemsByCarId"
                  >
                  <div class="blockAddFields">
                    <span class="tab-text-name">{{ item.name }}</span>
                    <span class="tab-text-art">{{ item.sku }}</span>
                  </div>
                </div>
              </div>
              <button 
                class="btn btn-default"
                type="submit"
                @click="saveItems(currentCarId)"
              >
                Сохранить
              </button>
            </div>
            <div v-else class="text-center">
              Товары не найдены.
            </div>
          </div>
        </div>

        <span 
          v-if="objectNewOrder.shipmentMethod == 'Доставка' && objectNewOrder.region_id && !carsHaveEmptyItems"
          class="btn-add vid-ps btn-default mt-20"
          @click="addOrderCar()"
        >
          <mdicon 
            name="plus" 
            width="18" 
            height="18" 
          />
          Добавить машину
        </span>

        <!-- Блок с дополнительными услугами -->
        <accordion class="accordion-block accordion-pd-0 create-block" :openBlock="openBlockServices" title="Дополнительные услуги" type="services">
          <div class="block-services">
            <div class="block-services-item service-head">
              <img src="@/assets/img/del.svg" class="pointer" title="Удалить выбранные услуги" @click="delSelectedService()">
              <span>Вид услуги</span>
            </div>
            <div class="block-services-item service-head">
              <span>Применить к машине:</span>
            </div>
          </div>
          <div class="block-services" v-for="(service) in objectNewOrder.services" :key="service.id">
            <div class="block-services-item vid-service">
              <span>
                <input 
                  type="checkbox" 
                  :value="service.id"
                  v-model="selectedServicesDel"
                >{{ service.title }}</span>
            </div>
            <div class="block-services-item for-good">
              <div class="group-label-input container-input-btn-service"> 
                <span 
                  class="btn-add vid-ps btn-default"
                  @click="getOrderCarsService(service.id)"
                >
                  <mdicon 
                    name="plus" 
                    width="18" 
                    height="18" 
                  />
                  Добавить машину
                </span>
              </div>  
              <div class="group-good" v-for="(itemService) in service.cars" :key="itemService.id">
                <div>
                  <span class="tab-text-name">Машина №{{ itemService.id }}</span>
                </div>
              </div>
            </div>
          </div>

          <div v-if="showModalAddItemsService" class="modal-vue modal-add-items" :class="{ 'fade-in': showModalAddItemsService, 'fade-out': !showModalAddItemsService }">
            <span class="container-icon" title="Закрыть" @click="closeModal('addItemsService')">
              <mdicon name="close" width="22" height="22"/> 
            </span>
            
            <div>
              <p class="modal-title">Выберите машины</p>
              <div v-if="orderCarsService.length > 0">
                <div class="container-add-items">
                  <div 
                    class="block-cb block-field-hover"
                    @click="selectOrderAllCarsService(selectService)"
                  >
                    <input 
                      type="checkbox" 
                      :value="selectService"
                      v-model="addOrderAllCarsService"
                    >
                    <div class="blockAddFields">
                      <span class="tab-text-art">Отметить все</span>
                    </div>
                  </div>
                  <div 
                    class="block-cb block-field-hover"
                    v-for="(car) in orderCarsService"
                    :key="car"
                    @click.stop="addCar(car)"
                    :class="[selectedCarsService.includes(car) ? 'active-field' : '']"
                  >
                    <input 
                      type="checkbox" 
                      :value="car"
                      v-model="selectedCarsService"
                    >
                    <div class="blockAddFields">
                      <span class="tab-text-name">Машина №{{ car }}</span>
                    </div>
                  </div>
                </div>
                <button 
                  class="btn btn-default"
                  type="submit"
                  @click="saveCarsService(selectService)"
                >
                  Сохранить
                </button>
              </div>
              <div v-else class="text-center">
                Машины не найдены.
              </div>
            </div>

          </div>

          <span 
            class="btn-add vid-ps btn-default"
            @click="addOrderServices()"
          >
            <mdicon 
              name="plus" 
              width="18" 
              height="18" 
            />
            Добавить услугу
          </span>

          <div v-if="showModalAddService" class="modal-vue modal-add-items" :class="{ 'fade-in': showModalAddService, 'fade-out': !showModalAddService }">
            <span class="container-icon" title="Закрыть" @click="closeModal">
              <mdicon name="close" width="22" height="22"/> 
            </span> 

            <div class="container-loading-modal" v-if="!flagGetService">
              <span class="loader loader-default loader-dark"></span>
            </div>
            <div v-else>
              <p class="modal-title">Выберите услуги</p>
              <div class="container-add-items">
                <div 
                  class="block-cb block-field-hover"
                  @click="selectAllServices()"
                >
                  <input 
                    type="checkbox" 
                    value="1"
                    v-model="addAllServices"
                  >
                  <div class="blockAddFields">
                    <span class="tab-text-art">Отметить все</span>
                  </div>
                </div>
                <div 
                  class="block-cb block-field-hover"
                  v-for="(service) in orderServices"
                  :key="service"
                  @click="addService(service.id)"
                  :class="[selectedServices.includes(service.id) ? 'active-field' : '']"
                >
                  <input 
                    type="checkbox" 
                    :value="service.id"
                    v-model="selectedServices"
                  >
                  <div class="blockAddFields">
                    <span class="tab-text-name">{{ service.title }}</span>
                    <span class="tab-text-art">{{ service.description }}</span>
                  </div>
                </div>
              </div>
              <button 
                class="btn btn-default"
                type="submit"
                @click="saveService()"
              >
                Сохранить
              </button>
            </div>
          </div>
        </accordion>
      </div>
  
      </section>
      <div class="container-buttons">
        <!-- <button class="btn btn-default" type="submit">
          <mdicon name="filter" width="17px"/> 
          Разделить
        </button> -->
        <button 
          class="btn btn-default" 
          type="submit" 
          @click="calculateOrder()" 
          v-bind:disabled="loadSaveOrder || loadPostOrder"
        >
          <mdicon name="view-grid-outline" width="17px"/> 
          Рассчитать
        </button>
        <button 
          class="btn btn-default" 
          type="submit" 
          @click="saveOrder()" 
          v-bind:disabled="loadSaveOrder || loadPostOrder"
        > 
          <span v-if="loadSaveOrder" class="loader loader-for-btn"></span>
          <div v-else>
            <mdicon name="tray-arrow-down" width="17px"/> 
            Сохранить
          </div>
        </button>
        <button 
          class="btn btn-success" 
          type="submit" 
          @click="postOrder()" 
          v-bind:disabled="loadSaveOrder || loadPostOrder"
        >
          <span v-if="loadPostOrder" class="loader loader-for-btn"></span>
          <div v-else>
            <mdicon name="file-check-outline" width="17px"/> 
            Разместить
          </div>
        </button>
      </div>
    </div>
  </transition>

  <address-form
    v-if="showFormAddAddress"
    :newAddressArrayForm="newAddressArrayForm"
    @saveAddress = "saveAddress"
    @closeModal = "closeModal"
    @updateNewAddressArrayForm = "updateNewAddressArrayForm"
  ></address-form>

  <confirm-modal ref="confirmModal"></confirm-modal>

  <div v-if="showModalAddItems || showModalAddService || showModalAddItemsService || showFormAddAddress" class="overlay"></div>

</template>

<script>
import TopNavbar from "../components/TopNavbar.vue";
import Accordion from "../components/Accordion.vue";
import GlobalRequest from "@/plugins/globalRequest";
import DatePicker from 'vuejs3-datepicker';
import ShipmentAddressField from '../components/ShipmentAddressField.vue';
import AddressForm from '../components/AddressForm.vue';
import ConfirmModal from '../components/ConfirmModal.vue';
import SelectComponent from "../components/SelectComponent.vue";
import { mapGetters } from 'vuex';
import { mask } from 'vue-the-mask';

export default {
  name: 'OrderCreatePage',
  components: {
    TopNavbar,
    Accordion,
    DatePicker,
    ShipmentAddressField,
    AddressForm,
    ConfirmModal,
    SelectComponent
  },
  directives: {
    mask
  },
  data() {
    return {
      searchingOrderAllItems: false,
      searchingOrderServiceItems: false,
      // occupancyRate: 0,
      loadSaveOrder: false,
      loadPostOrder: false,
      loadingItems: false,
      showEditQuantity: 0,
      showEditArea: 0,
      showEditVolume: 0,
      showEditCountServiceItem: 0,
      showEditCountServiceId: 0,
      showPriceTypes: 0,
      showModalAddItemsService: false,
      showModalAddItems: false,
      showModalAddService: false,
      textForSearchItemsAdd: '',
      minDate: {},
      currentDateShipment: new Date(),
      objectOrderDraft: {},
      selectedCarsService: [],
      selectedCarsServiceWithObj: [],
      selectedItems: [],
      selectedItemsDel: {},
      selectedServices: [],
      selectedServicesDel: [],
      isOrderNum: false,
      allServices: [],
      originOrderAllItems: [],
      orderAllItems: [],
      orderCarsService: [],
      orderAllItemsSearch: [],
      addOrderAllItems: [],
      addOrderAllCarsService: [],
      addAllServices: [],
      serviceItemsForNewOrder: [],
      openBlockServices: true,
      flagGetService: false,
      flagGetItems: false,
      selectService: 0,
      errorText: "",
      successText: "",
      orderServices: [],
      isReady: false,

      allRelatedOrders: [],
      originAllRelatedOrders: [],
      objectNewOrder: {
        creationDate: "",
        orderStatus: "",
        division: "", // выбор
        shipmentMethod: "",
        region: "",
        shipmentAddress: "",
        addInformation: "",
        consignee: null,
        inn: null,
        cars: [
          {
            carId: 1,
            summ: 0,
            orderWeight: 0,
            occupancyRate: 0,
            shipmentDate: null,
            relatedOrders: [],
            items: []
          }
        ],
        items: [],
        services: [],
        load: null
      },
      idGetOrder: "",
      getAddons: false,
      searchTimeout: null,
      idGetKP: "",
      basedOnKP: false,
      dataBasedOnKP: {},
      incorrectInn: false,
      incorrectAddress: false,
      selectedAddress: false,
      showFormAddAddress: false,
      haveNewAddress: false,
      orderError: "",
      currentCarId: 0,
      selectedRelated: [],
      carsHaveEmptyItems: true,
      clearSelected: false,
      newAddressArrayForm: [],
      currUserID: null,
      shipmentDatesByCarId: {},
      suppressCarsWatch: false,
    }
  },

  computed: {
    ...mapGetters(['getOrderData']), // Подключаем геттер

    // Выбранные товары
    selectedItemsByCarId() {
      const rec = this.selectedItems.find(o => o.carId == this.currentCarId);
      return rec ? rec.selected : [];
    },

    itemsByCarId() {
      return new Map((this.orderAllItems ?? [])
        .map(x => [String(x.carId), x.items ?? []]));
    },

    originItemsByCarId() {
      return new Map((this.originOrderAllItems ?? [])
        .map(x => [String(x.carId), x.items ?? []]));
    },

  },

  async mounted() { 

    if(localStorage.getItem('userID') != undefined && localStorage.getItem('userID') != '') {
      this.currUserID = localStorage.getItem('userID')
    }
    
    await this.init()
  },

  watch: {
    // Отследить изменение поля поиска в блоке товаров
    textForSearchItemsAdd: {
      handler(val) {
        if(!this.isEmpty(val)) {
          if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
          }

          // Проверки для красоты прелоадера
          if (val.length > 2) {
            this.searchingOrderAllItems = true
          }
          else {
            this.orderAllItems = JSON.parse(JSON.stringify(this.originOrderAllItems))
            this.searchingOrderAllItems = false
          }

          // Выполнение проверки поля и выполненя поиска с задержкой в 2 секунды
          this.searchTimeout = setTimeout(() => {
            if (val.length > 2) {
              this.checkObjectForItems(val, 'orderAllItems');
              this.searchingOrderAllItems = false
            }
          }, 1500);
        }
        else {
          this.orderAllItems = JSON.parse(JSON.stringify(this.originOrderAllItems))
        }
      },
      deep: true
    },

    // Изменения получения товаров на разные регионы и типы
    'objectNewOrder.division': {
      async handler() { 

        for (const car of this.objectNewOrder.cars) {
          await new Promise(resolve => setTimeout(resolve, 400));
          this.clearRelatedOrders(car.carId)

          if(car.shipmentDate && !this.isEmpty(this.objectNewOrder.region_id)) {
            this.loadingItems = true
            this.flagGetItems = false
            this.clearItems()
            this.orderAllItemsSearch = []

            this.getOrderItemsAddon()
          }

        }
      },
      deep: true
    },

    // Изменение способа доставки, каждый раз получаем регионы с фильтрацией по shipmentMethod
    'objectNewOrder.shipmentMethod': {
      async handler(val) {
        
        for (const car of this.objectNewOrder.cars) {
          await new Promise(resolve => setTimeout(resolve, 400));
          this.clearRelatedOrders(car.carId)

          if(
            car.shipmentDate 
            && !this.isEmpty(this.objectNewOrder.region_id) 
            && !this.isEmpty(this.objectNewOrder.division)
          ) {
            this.getOrderItemsAddon()
          }

        }

        // Оставить только первую машину
        if(this.objectNewOrder.shipmentMethod == 'Самовывоз') {
          this.objectNewOrder.cars[0].items = []
          this.objectNewOrder.cars = [this.objectNewOrder.cars[0]]

          this.selectedItems = []
        }

        this.orderAllItems = []
        this.originOrderAllItems = []
        await this.getRegions(val)

      },
      deep: true
    },
    
    'objectNewOrder.region_id': {
      async handler() {
        
        for (const car of this.objectNewOrder.cars) {
          await new Promise(resolve => setTimeout(resolve, 400));
          this.clearRelatedOrders(car.carId)

          if(car.shipmentDate && !this.isEmpty(this.objectNewOrder.division) && !this.isEmpty(this.objectNewOrder.shipmentMethod)) {
            this.loadingItems = true
            this.flagGetItems = false
            this.clearItems()
            this.orderAllItemsSearch = []

            this.getOrderItemsAddon()
          }

        }
        
        if(this.isEmpty(this.objectNewOrder.region_id)) {
          this.objectNewOrder.cars[0].items = []
          this.objectNewOrder.cars = [this.objectNewOrder.cars[0]]

          this.selectedItems = []
        } else {
          // Получить список доступных связанных заказов
          await this.getRelatedOrders(this.objectNewOrder.region_id)
        }
        
      },
      deep: true
    },

    // Следим за изменениями в объекте машин товаров
    'objectNewOrder.cars': {
      async handler(newValueCar) {
        if (!Array.isArray(newValueCar)) return;
        if (this.suppressCarsWatch) return;

        this.suppressCarsWatch = true;

        try {
          // Проверка количества товаров в машине
          let carItems = newValueCar.filter(car => car.items.length < 1)
          if(carItems.length > 0) {
            this.carsHaveEmptyItems = true
          } else {
            this.carsHaveEmptyItems = false
          }

          // Проверка на наличие заказов в relatedOrders
          const relatedCarIds = newValueCar
            .filter(car => car.relatedOrders && car.relatedOrders.length > 0) // Фильтруем машины с связанными заказами
            .map(car => car.carId); // Извлекаем carId

          const hasRelatedOrders = relatedCarIds.length > 0; // Есть ли связанные заказы

          // Если есть связанные зказы в машине, то добавляем услугу и id машины в эту услугу
          // Иначе удаляем из услуги и если она остается пустая, то ее саму тоже удаляем

          // Выбираем нужную услугу из всех получееных, выполняем действия, если эта услуга есть в списке
          let service = this.orderServices.find(service => service.title == "Доставка на несколько адресов");
          if(service) {
            if (hasRelatedOrders) {

              // Добавлять услугу, если она еще не добавлена
              if (!this.selectedServices.includes(service.id)) {
                this.selectedServices.push(service.id)
                this.saveService()
              }

              this.orderCarsService = []
              for(let car of this.objectNewOrder.cars) {
                this.orderCarsService.push(car.carId)
              }

              // Добавить id машин в услуги
              for(let id of relatedCarIds) {
                this.addCar(id)
              }
              this.saveCarsService(service.id) 

            } else {
              this.selectedServices = this.selectedServices.filter(id => id !== service.id);
              this.saveService()
            }
          }

          const changedIds = [];

          // Отслеживание изменения количества товара
          newValueCar.forEach((car) => {
            car.items.forEach((item) => {
              if(item.quantity <= 0) {
                item.quantity = 1
              }
            })

            if(this.basedOnKP && !car.shipmentDate) {
              car.shipmentDate = this.minDate?.to ? new Date(this.minDate.to) : null
            }

            const sig = car.shipmentDate;
            const prev = this.shipmentDatesByCarId[car.carId];

            // если дата у этой машины изменилась — запомним и поставим на загрузку
            if (prev != sig) {
              this.shipmentDatesByCarId[car.carId] = sig;
              if (sig) changedIds.push(car.carId);
            }

          });

          if (
            changedIds.length
            && !this.isEmpty(this.objectNewOrder.division) 
            && !this.isEmpty(this.objectNewOrder.shipmentMethod) 
            && !this.isEmpty(this.objectNewOrder.region_id)
          ) {
            // точечно грузим только изменившиеся машины
            for (const id of changedIds) {
              await this.getOrderItemsAddon(id);
            }
          }

          let clearRelatedCars = newValueCar.filter(car => car.relatedOrders.length > 0 && (car.occupancyRate <= 0 || car.occupancyRate >= 100))
          clearRelatedCars.forEach((car) => {
            this.clearRelatedOrders(car.carId)
          });

          // Рассчитывать шапку при каждом изменении в машине
          this.calculateOrder()
        } finally {
          this.suppressCarsWatch = false;
        }
      },
      deep: true
    },

  },

  methods: {

    async init() {
      if(this.getOrderData[this.$route.query.key]) {
        this.dataBasedOnKP = this.getOrderData[this.$route.query.key].data
      }
      
      // Если получен параметр, значит заказ создается на основе КП
      this.idGetKP = this.$route.query.idKP 
      if(this.dataBasedOnKP) {
        if(this.idGetKP && Object.keys(this.dataBasedOnKP).length > 0) 
          this.basedOnKP = true
      }

      this.isReady = false
      this.idGetOrder = this.$route.query.id

      await this.getObjOrderDraft()
      if(this.isEmpty(this.objectOrderDraft)) {
        this.errorText = "Данные для предзаполнения не были получены"
      }
      else {
        if(this.isEmpty(this.objectOrderDraft.contrAgent)) {
          this.errorText = "Для создания заказа необходимо добавить юридическое лицо, которое будет производить оплату. Обратитесь в клиентский сервис за помощью."
        }
        else {
          const values = Object.values(this.objectOrderDraft.contrAgent);
          this.objectNewOrder.contrAgent = values[0]

          await this.getOrderServices()
          if(this.isEmpty(this.orderServices)) {
            this.errorText = "Доступные услуги не были получены"
          }
        }
      }

      // Объект даты для доставки, нельзя выбрать сегодня и завтра
      let minDate = this.currentDateShipment.setDate(this.currentDateShipment.getDate() + 2)
      let objDate = {}
      objDate.to = new Date(minDate)
      this.minDate = objDate 

      // Если получен параметр на копирование заказа по id
      if(!this.isEmpty(this.idGetOrder)) {
        await this.getCopyObj()
      }
      
      // Если заказ не скопированный
      if(this.isEmpty(this.idGetOrder)) {
        this.objectNewOrder.status = this.objectOrderDraft.orderStatus
        this.objectNewOrder.created = this.objectOrderDraft.creationDate
      }

      // Если заказ создан на базе КП
      if(this.basedOnKP) {
        await this.selectOrderValues()
      }

      this.isReady = true
    },

    // Заполнить тип продукции, способ доставки и регион
    async selectOrderValues() {
      this.objectNewOrder.division = this.dataBasedOnKP.division
      this.objectNewOrder.region_id = this.dataBasedOnKP.region

      // Ищем соответствующий тип доставки по региону (изменилась логика, теперь на самовывоз тоже появился регион)
      for(let shipmentMethod of this.objectOrderDraft.deliveryMethods) {
        let res = await GlobalRequest.request("/region/list?shipmentMethod=" + shipmentMethod, "GET")
        if(res.success) {
          let region = res.data.find(region => region.id == this.objectNewOrder.region_id);
          if (region) {
            this.objectNewOrder.shipmentMethod = shipmentMethod;
            break; // Выходим из цикла, если регион найден
          }
        }
      }

      // this.objectNewOrder.shipmentMethod = "Доставка"
    },

    formatDMYHI(input) {
      const d = new Date(input);
      if (isNaN(d)) return ''; // защита
      const pad = n => String(n).padStart(2, '0');
      return `${pad(d.getDate())}.${pad(d.getMonth()+1)}.${d.getFullYear()}`;
    },
    
    // Получить скопированный объект заказа
    async getCopyObj() {
      // Получить заказ
      let res = await GlobalRequest.request("/order/" + this.idGetOrder + "/copy", "GET")
      if(res.success) {
        this.objectNewOrder = res.data // получить данные скопированного заказа

        this.objectNewOrder.cars = [
          {
            carId: 1,
            summ: 0,
            orderWeight: 0,
            occupancyRate: 0,
            shipmentDate: this.minDate?.to ? new Date(this.minDate.to) : null,
            relatedOrders: [],
            items: []
          }
        ]
        
        // получить регионы
        await this.getRegions(this.objectNewOrder.shipmentMethod)

        // delete this.objectNewOrder.shipmentDate
        this.objectNewOrder.created = this.formatDate(this.objectNewOrder.created)
        this.objectNewOrder.status = "Черновик"
        this.objectNewOrder.region_id = this.objectNewOrder.region.id
        this.objectNewOrder.services = []

        this.selectedAddress = this.objectNewOrder.shipmentAddress

        // Проверка региона на актуальность и заполнение товаров или удаление
        if(!this.objectOrderDraft.regions.some(region => region.id === this.objectNewOrder.region_id)) {
          for( let car of this.objectNewOrder.cars ) {
            car.items = []
          }
        }
        else {
          // Проверка актуальности товаров на выбранный регион
          let res1 = ""
          let allItems = ""

          if(!this.isEmpty(this.objectNewOrder.contrAgent) && !this.isEmpty(this.objectNewOrder.region_id) && !this.isEmpty(this.objectNewOrder.division)) {
            // Дата отгрузки машины в виде d.m.Y
            let dateNormal = this.formatDMYHI(this.objectNewOrder.cars[0].shipmentDate)

            res1 = await GlobalRequest.request(
            `/order/items?contrAgentId=${this.objectNewOrder.contrAgent.id}` +
            `&regionId=${this.objectNewOrder.region_id}` +
            `&division=${this.objectNewOrder.division}` +
            `&shipmentDate=${dateNormal}`,
            "GET"
          );

            if(res1.success) {
              allItems = res1.data
            }
          }

          // Заполнить товрами машину
          let carItems = JSON.parse(JSON.stringify(this.objectNewOrder.items))
          this.objectNewOrder.cars[0].items = carItems

          delete this.objectNewOrder.items // удалить массив 


          let delItems = []
          // Массив с выборкой товаров
          let objectSelectedCar = {}
          objectSelectedCar.carId = 1
          objectSelectedCar.selected = []
          this.selectedItems.push(objectSelectedCar) 

          for(let car of this.objectNewOrder.cars) {
            for(let item of car.items) {
              item.selectedPriceType = ""

              item.originId = item.id
              item.id = item.itemId
              delete item.itemId

              if(allItems.some(item1 => item1.id == item.id)) {
                let carSelectedItem = this.selectedItems.find(obj => obj.carId == car.carId);
                carSelectedItem.selected.push(item.id)
                
                item.priceTypes = item.availablePriceTypes
              }
              else {
                delItems.push(item.id)
              }
              
            }
            // Убрать неактуальные
            car.items = car.items.filter(item => !delItems.includes(item.id));
          }

          this.selectService = 0
        }

        this.orderError = ""
      } else {
        this.objectNewOrder = {}
        this.orderError = "Ошибка получения скопированного заказа"
      }
    },

    // Изменение желаемой даты отгрузки
    updateShipmentDate(car) {
      this.clearRelatedOrders(car.carId)
    },

    clearRelatedOrders(id) {
      const carActive = this.objectNewOrder.cars.find(car => car.carId == id);

      if (!carActive) {
        return;
      }

      if (!Array.isArray(carActive.relatedOrders) || carActive.relatedOrders.length === 0) {
        return;
      }

      this.clearSelected = id;
      carActive.relatedOrders = [];

      setTimeout(() => {
        if (this.clearSelected === id) {
          this.clearSelected = false;
        }
      }, 300);
    },

    // Получение регионов с фильтрацией по методу доставки
    async getRegions(shipmentMethod) {
      let res = await GlobalRequest.request("/region/list?shipmentMethod=" + shipmentMethod, "GET")
      if(res.success)
        this.objectOrderDraft.regions = res.data
      else
        this.objectOrderDraft.regions = []
      
        if(!this.objectOrderDraft.regions.some(region => region.id === this.objectNewOrder.region_id)) {
          this.objectNewOrder.region_id = ''
        }

    },

    togglePriceTypes(car, item) {
      if(item.priceTypes) {
        this.showPriceTypes = car.carId + "-" + item.rowId
      }
    },

    // Закрыть модалку
    closeModal(typeModal) {
      if ( typeModal == "addItems" ) {
        this.showModalAddItems = false;
      }
      else if ( typeModal == "addItemsService" ) {
        this.showModalAddItemsService = false;
        this.selectedCarsService = []
      }
      
      this.showModalAddService = false;
      this.showPriceTypes = 0;

      this.showFormAddAddress = false
    },

    // Добавить/Удалить id заголовка для таблицы в массив. Объекты: товары, товары в услугах, услуги
    addItem(itemId, objectItems) {
      let obj = objectItems.find(o => o.carId == this.currentCarId)

      // если объекта для машины нет — создаём
      if (!obj) {
        obj = {
          carId: this.currentCarId,
          selected: []
        }
        objectItems.push(obj)
      }

      const idx = obj.selected.indexOf(itemId)

      if (idx !== -1) {
        obj.selected.splice(idx, 1)
      } else {
        obj.selected.push(itemId)
      }

      // let carItems = objectItems.find(obj => obj.carId == this.currentCarId).selected

      // if(carItems.includes(itemId)) {
      //   carItems = carItems.filter(element => element != itemId);
      // } else {
      //   carItems.push(itemId);
      // }
      // objectItems.find(obj => obj.carId == this.currentCarId).selected = carItems
    },

    addService(serviceId) {
      if(this.selectedServices.includes(serviceId)) {
        this.selectedServices = this.selectedServices.filter(element => element != serviceId);
      }
      else
        this.selectedServices.push(serviceId);
    },

    addCar(car) {
      if(this.selectedCarsService.includes(car)) {
        this.selectedCarsService = this.selectedCarsService.filter(element => element != car)
      }
      else {
        this.selectedCarsService.push(car);
      }
    },

    selectOrderAllItems(carId) {
      // Получаем все id всех элементов
      const itemsId = this.getCarItems(this.orderAllItems, carId).map(item => item.id);

      if(this.addOrderAllItems.includes(carId)) {
        this.addOrderAllItems = []
        
        // Удаляем только те элементы, которые относятся к текущему carId
        let itemsSelected = this.selectedItems.find(obj => obj.carId == carId).selected
        this.selectedItems.find(obj => obj.carId == carId).selected = itemsSelected.filter(id => !itemsId.includes(id));
      } else {
        // Если carId не в выбранных элементах, добавляем новые
        this.addOrderAllItems.push(carId);
        
        // Добавляем элементы в соответствующий объект в selectedItems
        const selectedObj = this.selectedItems.find(obj => obj.carId == carId);
        
        if (selectedObj) {
          // Объединяем существующие и новые выбранные элементы, убираем дубликаты
          selectedObj.selected = Array.from(new Set([...selectedObj.selected, ...itemsId]));
        } else {
          // Если объекта с этим carId нет, создаем новый
          this.selectedItems.push({
            carId: carId,
            selected: itemsId
          });
        }
      }
    },

    // Выбрать все чекбоксы или очистить 
    selectOrderAllCarsService(serviceId) {
      if(this.addOrderAllCarsService.includes(serviceId)) {
        this.addOrderAllCarsService = []
        this.selectedCarsService = []
      }
      else {
        this.addOrderAllCarsService.push(serviceId)
        for(let index in this.orderCarsService) {
          let item = this.orderCarsService[index]
          this.selectedCarsService.push(item)
        }
      }
    },

    // Выбрать все чекбоксы или очистить 
    selectAllServices() {
      if(this.addAllServices.includes("1")) {
        this.addAllServices = []
        this.selectedServices = []
      }
      else {
        this.addAllServices.push("1")
        for(let index in this.orderServices) {
          let item = this.orderServices[index]
          this.selectedServices.push(item.id)
        }
      }
    },

    // Сохранить выбранные товары для машины с товарами
    saveItems(carId) {
      // машина и выбранные ID для неё
      const orderCar = (this.objectNewOrder.cars || []).find(c => c.carId == carId);
      const selectedObj = (this.selectedItems || []).find(o => o.carId == carId);

      if (!orderCar || !selectedObj) return;

      const selectedIds = selectedObj.selected || [];

      // пул доступных товаров для этой машины (ИСТОЧНИК)
      const originForCar = this.getCarItems(this.originOrderAllItems, carId) || [];

      // только выбранные позиции из источника
      // const baseItems = originForCar.filter(it => selectedIds.includes(it.id));

      // подготовим новые элементы: если уже есть в машине — берём существующий,
      // иначе создаём с дефолтными полями
      // const arrayItems = [];
      // for (const it of baseItems) {
      //   const existed = (orderCar.items || []).find(x => x.id == it.id);
      //   if (existed) {
      //     arrayItems.push(existed);
      //   } else {
      //     arrayItems.push({
      //       ...it,
      //       selectedPriceType: "",
      //       itemPrice: "",
      //       priceType: "",
      //       total: "",
      //       proposalId: "",
      //       quantity: 1,
      //     });
      //   }
      // }

      // оставляем из текущих только те, что всё ещё отмечены, и добавляем новые без дублей
      // const current = orderCar.items || [];
      // const keep = current.filter(x => selectedIds.includes(x.id));
      // orderCar.items = [
      //   ...keep,
      //   ...arrayItems.filter(x => !keep.some(k => k.id == x.id)),
      // ];

      selectedIds.forEach(id => {
        const src = originForCar.find(i => i.id === id)
        if (!src) return

        // ВСЕГДА добавляем новый товар
        orderCar.items.push({
          ...JSON.parse(JSON.stringify(src)),
          
          rowId: this.generateRowId(),

          selectedPriceType: "",
          itemPrice: "",
          priceType: "",
          total: "",
          proposalId: "",
          quantity: 1,
        })
      });

      selectedObj.selected = []

      // закрыть модалку/сбросить состояние
      this.showModalAddItems = false;
      this.getAddons = true;
      this.currentCarId = 0;

      this.resetEditFields();
    },


    // Сохранить выбранные машины для блока услуг
    saveCarsService(serviceId) {
      let newArr = []
      for(let item of this.orderCarsService) {
        if(this.selectedCarsService.includes(item))
          newArr.push(item)
      }
      this.selectedCarsService = newArr

      let arrayCars = []
      // все машины
      for(let carId of this.orderCarsService) { 
        // Если в массиве id выбранных машин для услуг есть товар 
        if(this.selectedCarsService.includes(carId)) {
          // Проверка на наличие этого товара в услугах
          for (let service of this.objectNewOrder.services) {
            if(service.id == serviceId) { // если service равно выбранному
              if(!service.cars.some(car => car.id == carId)) {
                let obj = {}
                obj.id = carId
                arrayCars.push(obj)
              }
              else {
                if(!arrayCars.includes(carId))
                  arrayCars.push(service.cars.find(car => car.id == carId))
              }
            }
          }
        }
      }

      // дубли
      let uniqueCars = arrayCars.filter((item, index, self) =>
          index === self.findIndex((t) => (
              t.id === item.id
          ))
      );

      let jsonCars = JSON.stringify(uniqueCars)
      uniqueCars = JSON.parse(jsonCars)

      for (let service of this.objectNewOrder.services) {
        if (service.id === serviceId) {
            service.cars = uniqueCars;
            break; // Выход из цикла, если объект найден
        }
      }

      if(this.selectedCarsServiceWithObj.some(item => item.serviceId === this.selectService)) {
        for(let item of this.selectedCarsServiceWithObj) {
          if(item.serviceId == this.selectService)
            item.carsId = this.selectedCarsService
        }
      }
      else {
        let obj = {}
        obj.serviceId = this.selectService
        obj.carsId = this.selectedCarsService
        this.selectedCarsServiceWithObj.push(obj)
      }

      this.selectedCarsService = []
      this.showModalAddItemsService = false
    },

    // Сохранить выбранные услуги
    saveService() {
      let arrayServices = [] 

      for(let key in this.orderServices) {
        // Если массив выбранных услуг содержит id услуги
        if(this.selectedServices.includes(this.orderServices[key].id)) {

          if(!this.objectNewOrder.services.some(item => item.id === this.orderServices[key].id)) {
            this.orderServices[key].cars = []
            arrayServices.push(this.orderServices[key])
          }
          else {
            arrayServices.push(this.objectNewOrder.services.find(item => item.id === this.orderServices[key].id))
          }
        } else {
          // Удаляем выбранные машины
          this.selectedCarsServiceWithObj = this.selectedCarsServiceWithObj.filter(item => item.serviceId != this.orderServices[key].id);
        }
      }
      this.objectNewOrder.services = arrayServices
      this.showModalAddService = false
    },

    checkObjectForItems(val, type) { 
      let searchingStr = val.toLowerCase()

      const allItems = JSON.parse(JSON.stringify(this.originOrderAllItems))
      let allItemsForCar = this.getCarItems(allItems, this.currentCarId)

      const car = this.orderAllItems.find(x => x.carId == this.currentCarId);

      // Проверка массива с товарами на наличие подстроки а названии или артикуле 
      if( type == 'orderAllItems' && car)
        
        car.items = allItemsForCar.filter(item => item.name.toLowerCase().includes(searchingStr) || item.sku.toLowerCase().includes(searchingStr))
    },

    // Проверка отмеченных товаров при открытии модалки с выбором
    checkSelectedItemsInOpenModal() {
      let newSelectedItems = []

      // Текущая машина
      let currentCar = this.objectNewOrder.cars.find(car => car.carId == this.currentCarId)
      for(let key in currentCar.items) {
        newSelectedItems.push(currentCar.items[key].id)
      }

      const cur = this.selectedItems.find(o => o.carId == this.currentCarId);
      
      if (cur) {
        cur.selected = newSelectedItems;
      } else {
        this.selectedItems.push({ carId: this.currentCarId, selected: newSelectedItems });
      }
    },

    // Проверка отмеченных машин при открытии окна выбора для услуги
    checkSelectedCarsInOpenModal() {

      if(this.selectedCarsServiceWithObj.length > 0) {
        if(!this.isEmpty(this.selectedCarsServiceWithObj.find(serv => serv.serviceId == this.selectService))) {
          this.selectedCarsService = this.selectedCarsServiceWithObj.find(serv => serv.serviceId == this.selectService).carsId
        }
      }
      else {
        this.selectedCarsService = []
      }
    },

    // Данные для предзаполнения
    async getObjOrderDraft() {
      let res = await GlobalRequest.request("/order/draft", "GET")
      if(res.success) {
        this.orderError = ""
        this.objectOrderDraft = res.data
        this.objectOrderDraft.regions = [] // массив регионов
      }
      else {
        this.orderError = "Ошибка получения данных для предзаполнения заказа"
      }

      console.log("DRAFT")
      console.log(this.objectOrderDraft)
    },

    // Получить все услуги
    async getOrderServices() {
      let res = await GlobalRequest.request("/service/list", "GET")
      if(res.success) {
        this.orderServices = res.data
        this.flagGetService = true
      }

      console.log("SERVICES")
      console.log(this.orderServices)
    },
    
    // Показать окно с выбором услуг для заказа
    async addOrderServices() {
      this.showModalAddService = true
    },

    // Очистить все доступные товары, при смене способа доставки и региона(по условию)
    clearItems() {
      this.orderAllItems = []
      this.originOrderAllItems = []
      this.resetEditFields()
    },

    resetEditFields() {
      this.showEditQuantity = 0
      this.showEditArea = 0
      this.showEditVolume = 0
      this.showPriceTypes = 0
    },

    // Получить товары
    // Вызов при смене региона, способа доставки и типа продукции
    // Привязка к желаемой дате доставки
    async getOrderItemsAddon(idEditingCar) {
      console.log("ADDONS")

      // Получить товары запросом
      if (
        !this.isEmpty(this.objectNewOrder.contrAgent) &&
        !this.isEmpty(this.objectNewOrder.region_id) &&
        !this.isEmpty(this.objectNewOrder.division)
      ) {
        // 17.10.25 Получение товаров для каждой машины на основе выбранной даты отгрузки
        for(let car of this.objectNewOrder.cars) {

          // Если в метод передан id машины, то получаем товары только для нее, иначе для всех машин
          if(idEditingCar && idEditingCar != car.carId) continue;

          // Дата отгрузки машины в виде d.m.Y
          let dateNormal = this.formatDMYHI(car.shipmentDate)

          const res = await GlobalRequest.request(
            `/order/items?contrAgentId=${this.objectNewOrder.contrAgent.id}` +
            `&regionId=${this.objectNewOrder.region_id}` +
            `&division=${this.objectNewOrder.division}` +
            `&shipmentDate=${dateNormal}`,
            "GET"
          );

          if (!res.success) continue;

          const nextOrigin = (this.originOrderAllItems ?? []).filter(x => x.carId != car.carId);
          nextOrigin.push({ carId: car.carId, items: res.data });
          this.originOrderAllItems = nextOrigin;

          // Если модалка сейчас открыта для этой машины — обновим рабочую копию
          if (this.showModalAddItems && this.currentCarId === car.carId) {
            this.orderAllItems = [{ carId: car.carId, items: JSON.parse(JSON.stringify(res.data)) }];
          }

          const pool = res.data || [];
          const poolById = new Map(pool.map(i => [i.id, i]));

          for (const orderNewItem of [...car.items]) {
            const ref = poolById.get(orderNewItem.id);

            if(ref) {
              // есть в общем списке — обновляем поля
              orderNewItem.priceTypes = ref.priceTypes;
              orderNewItem.selectedPriceType = '';
            } else {
              // нет в общем — убираем из текущей машины + из selected
              car.items = car.items.filter(i => i.id != orderNewItem.id);
              const sel = this.selectedItems.find(o => o.carId == car.carId);
              if (sel) sel.selected = sel.selected.filter(id => id != orderNewItem.id);
            }
          }

          // Подсчет позиций по количеству товаров
          car.items.forEach(item => {
            const carItems = this.getCarItems(this.originOrderAllItems, car.carId);
            const carItemIds = new Set(carItems.map(i => String(i.id)));

            if (item.quantity > 1 && carItemIds.has(String(item.id))) {
              this.calculateQuantity(item, car.carId);
            }

          });
        }

      }

      // Если на основе КП
      if(this.basedOnKP) {
        // Если на базе КП, то текущая машина первая для добавления товаров
        this.currentCarId = 1;
        
        // Новый объект для выборки товаров
        let objectSelectedCar = {}
        objectSelectedCar.carId = 1
        objectSelectedCar.selected = []

        this.dataBasedOnKP.items.forEach(item => {
          // В первую машину добавляем товары из КП
          objectSelectedCar.selected.push(item.id)
        });
        this.selectedItems= [objectSelectedCar] 

        // Сохранение товаров в машине
        this.saveItems(this.currentCarId)
        this.objectNewOrder.cars[0].items.forEach(item => {
          if(this.selectedItems[0].selected.includes(item.id)) {
            const itemQuantity = this.dataBasedOnKP.items.find(quantity => quantity.id === item.id);
            item.quantity = itemQuantity.quantity;

            // Выбираем тип цены
            const priceType = item.priceTypes.find(priceType => priceType.type == "proposal" && priceType.id == this.idGetKP);
            item.selectedPriceType = priceType
            this.getPriceType(priceType, item)
          }
        });
      }

      this.loadingItems = false
      this.clearSelected = false
    },


    // Показать окно с выбором товаров для машины
    getOrderItems(carId) {
      this.currentCarId = carId
      this.showModalAddItems = true
      this.flagGetItems = true
      
      this.addOrderAllItems = []
      this.textForSearchItemsAdd = ""

      const src = this.originItemsByCarId.get(String(carId)) ?? [];
      // рабочая копия для модалки — только товары текущей машины
      this.orderAllItems = [{ carId, items: JSON.parse(JSON.stringify(src)) }];

      // Синхронизация выбранных товаров с модалкой выбора товара
      // this.checkSelectedItemsInOpenModal()
    },

    // Показать окно с выбором машин для блока услуг
    getOrderCarsService(serviceId) {
      this.orderCarsService = []

      for(let car of this.objectNewOrder.cars) {
        this.orderCarsService.push(car.carId)
      }
      
      this.showModalAddItemsService = true
      this.addOrderAllCarsService = []
      this.selectService = serviceId
      this.checkSelectedCarsInOpenModal()
    },

    // Проверка на пустоту
    isEmpty(data) {
      if(data != "" && data != " " && data != 0 && data != null && data != undefined) {
        if(data.length > 0) return false
      }
      else {
        return true
      }
    },

    // Типы цен
    getPriceType(type, item) {
      item.selectedPriceType = type
      item.itemPrice = type.price
      item.priceTypeTitle = type.title
      item.priceType = type.type
      item.total = ""

      if(type.type == "proposal")
        item.proposalId = type.id
      else
        item.proposalId = null

      this.showPriceTypes = 0;
    },

    getBgPriceType(itemPS) {
      if(!itemPS.priceTypes) {
        return "gray-block-ps-type"
      }
      else {
        if(!this.isEmpty(itemPS.selectedPriceType)) {
          if(itemPS.selectedPriceType.title.includes("КП"))
            return "light-block-ps-type"
        }
      }
    },

    // Итоговая сумма, подсчет зависит от выбранного типа цены
    getItogItemSumm(item) {
      if(item.selectedPriceType == "") {
        return 0
      }
      else {
        let price = parseFloat(item.selectedPriceType.price)
        let quantity = parseInt(item.quantity)
        let itogSumm = price * quantity

        return (itogSumm).toFixed(2)
      }
    },

    // Изменить поле м2
    getEditArea(carId, rowId) {
      if(this.showEditArea == 0 && this.showEditVolume == 0 && this.showEditQuantity == 0) 
        this.showEditArea = carId + "-" + rowId
    },

    getEditVolume(carId, rowId) {
      if(this.showEditArea == 0 && this.showEditVolume == 0 && this.showEditQuantity == 0) 
        this.showEditVolume = carId + "-" + rowId
    },

    // поле ед
    getEditQuantity(carId, rowId) {
      if(this.showEditArea == 0 && this.showEditVolume == 0 && this.showEditQuantity == 0) 
        this.showEditQuantity = carId + "-" + rowId
    },

    // При изменении ед M2 должно пересчитываться по формуле:
    // Order_Item.Area = Order_Item.Quantity * Item.Area

    // При изменении ед M3 должно пересчитываться по формуле:
    // Order_Item.Volume = Order_Item.Quantity * Item.Volume

    // При изменении ед КГ должно пересчитываться по формуле:
    // Order_Item.Weight = Order_Item.Quantity * Item.Weight

    calculateQuantity(item, carId) {
      // округляем на всякий
      item.quantity = Math.round(item.quantity)
      if(item.quantity < 1) item.quantity = 1

      // Получить товар в изначальном виде,как в бд для расчета
      let itemsForCar = this.getCarItems(this.originOrderAllItems, carId)
      let originItem = itemsForCar.find(elem => elem.id === item.id);
      let itemArea = parseFloat(originItem.area);     
      let itemVolume = parseFloat(originItem.volume);   
      let itemWeight = parseFloat(originItem.weight);    

      // рассчет area
      item.area = (item.quantity * itemArea).toFixed(2);

      // рассчет volume
      item.volume = (item.quantity * itemVolume).toFixed(2);

      // рассчет weight
      item.weight = (item.quantity * itemWeight).toFixed(2);

      // Закрытие редактирования количества
      this.showEditQuantity = 0
    },

    // При изменении м2 ЕД должно пересчитываться по формуле:
    // Order_Item.Quantity = Order_Item.Area / Item.Area
    // Выводить значение с округлением до ближайшего целого числа.

    // При изменении м2 M3 должно пересчитываться по формуле:
    // Order_Item.Volume = Order_Item.Area / Item.Area * Item.Volume

    // При изменении м2 КГ должно пересчитываться по формуле:
    // Order_Item.Weight = Order_Item.Area / Item.Area * Item.Weight

    calculateArea(item, carId) { // m2
      
      // Получить товар в изначальном виде,как в бд для расчета
      let itemsForCar = this.getCarItems(this.originOrderAllItems, carId)
      let originItem = itemsForCar.find(elem => elem.id === item.id);
      let itemArea = parseFloat(originItem.area);     
      // После завершения редактирования поля пользователем должно произойти округление 
      // указанного в поле значения до ближайшего числа, кратного (Item.Area)
      if(parseFloat(item.area) < itemArea)
        item.area = itemArea
      else
        item.area = (Math.round(item.area / itemArea) * itemArea).toFixed(2);

      let orderItemArea = parseFloat(item.area);
      let itemVolume = parseFloat(originItem.volume); 
      let itemWeight = parseFloat(originItem.weight); 

      // рассчет quantity  
      item.quantity = Math.round(orderItemArea / itemArea);

      // рассчет volume  
      item.volume = (orderItemArea / itemArea * itemVolume).toFixed(2);

      // рассчет weight
      item.weight = (orderItemArea / itemArea * itemWeight).toFixed(2);

      this.showEditArea = 0
    },

    // При изменении м3 ЕД должно пересчитываться по формуле:
    // Order_Item.Quantity = Order_Item.Volume / Item.Volume
    // Выводить значение с округлением до ближайшего целого числа.

    // При изменении м3 М2 должно пересчитываться по формуле:
    // Order_Item.Area = Order_Item.Volume / Item.Volume * Item.Area

    // При изменении м3 КГ должно пересчитываться по формуле:
    // Order_Item.Weight = Order_Item.Volume / Item.Volume * Item.Weight

    calculateVolume(item, carId) { // m3
      // Получить товар в изначальном виде,как в бд для расчета
      let itemsForCar = this.getCarItems(this.originOrderAllItems, carId)
      let originItem = itemsForCar.find(elem => elem.id === item.id);
      let itemVolume = parseFloat(originItem.volume);

      // После завершения редактирования поля пользователем должно произойти округление 
      // указанного в поле значения до ближайшего числа, кратного Item.Volume
      if(parseFloat(item.volume) < itemVolume)
        item.volume = itemVolume
      else
        item.volume = (Math.round(item.volume / itemVolume) * itemVolume).toFixed(2);

      let orderItemVolume = parseFloat(item.volume);
      let itemArea = parseFloat(originItem.area);
      let itemWeight = parseFloat(originItem.weight); 

      // рассчет quantity
      item.quantity = Math.round(orderItemVolume / itemVolume);

      // рассчет area
      item.area = (orderItemVolume / itemVolume * itemArea).toFixed(2);

      // рассчет weight
      item.weight = (orderItemVolume / itemVolume * itemWeight).toFixed(2);

      this.showEditVolume = 0
    },

    // Проверка на количество штук, чтобы не превышало допустимого значения
    checkCountServiceItem(item) {
      // округляем на всякий
      item.quantity = Math.round(item.quantity)
      if(item.quantity < 1) item.quantity = 1

      let objectNewOrderItem = this.objectNewOrder.items.find(elem => elem.id == item.id)
      if(item.quantity > parseInt(objectNewOrderItem.quantity)) 
        item.quantity = parseInt(objectNewOrderItem.quantity)

      this.showEditCountServiceItem = 0
      this.showEditCountServiceId = 0
    },

    setItemVolume(item, newValue) {
      item.volume = newValue
    },

    flagEditFields(flag) {
      if(flag) return false
      else return true
    },

    // Удалить товары из машины
    delSelectedItems(carId) {

      // Получаем выбранные элементы для текущей машины
      const carSelectedItem = this.selectedItems.find(obj => obj.carId == carId);
      const carOrderItem = this.objectNewOrder.cars.find(car => car.carId == carId);

      // Проверяем, есть ли удаляемые элементы для текущего carId
      const itemsToDelete = this.selectedItemsDel[carId] || []; // Получаем массив по carId или пустой массив, если такого нет

      if (carSelectedItem) {
        // Обновляем массив selected, фильтруя удаляемые элементы
        carSelectedItem.selected = carSelectedItem.selected.filter(
          item => !itemsToDelete.includes(item) // Здесь item — это идентификатор товара
        );
      }

      if (carOrderItem) {
        // Обновляем массив items, фильтруя удаляемые элементы
        carOrderItem.items = carOrderItem.items.filter(
          item => !itemsToDelete.includes(item.rowId) // Здесь item.id — это идентификатор товара
        );
      }

      // Сбрасываем удаленные элементы после процессов обновления
      this.addOrderAllItems = [];
      this.selectedItemsDel = {};
    },

    delSelectedService() {
      this.selectedServices = this.selectedServices.filter(item => !this.selectedServicesDel.includes(item));
      this.selectedCarsService = []
      this.objectNewOrder.services = this.objectNewOrder.services.filter(service => !this.selectedServicesDel.includes(service.id));

      for(let serviceId of this.selectedServicesDel) {
        for(let car of this.selectedCarsServiceWithObj) {
          if(car.serviceId == serviceId) {
            car.carsId = []
          }
        }
      }

      this.addAllServices = []
      this.selectedServicesDel = []
    },

    calculateOrder() { // рассчет шапки
      for(let car of this.objectNewOrder.cars) {
        // вес
        let totalWeight = 0;
        for (let item of car.items) {
            let itemWeight = parseFloat(item.weight);
            totalWeight = totalWeight + itemWeight;
        }
        car.orderWeight = totalWeight.toFixed(2);

        // Процент загрузки
        let loadPercent = 0;

        for (let item of car.items) {
          const quantity = parseFloat(item.quantity) || 0;
          const packingDensity = parseFloat(item.packingDensity) || 0;

          if (quantity > 0 && packingDensity > 0) {
            loadPercent += quantity / packingDensity * 100;
          }
        }

        loadPercent = Math.ceil(loadPercent);

        if(isNaN(loadPercent)) {
          this.occupancyRate = 0
          car.occupancyRate = 0;
        }
        else {
          this.occupancyRate = loadPercent
          car.occupancyRate = loadPercent;
        }

        // Общая сумма
        let totalSumm = 0;
        for (let item of car.items) {
          let itemSumm = 0

          if(!this.isEmpty(item.selectedPriceType)) {
            itemSumm = parseInt(item.quantity) * parseFloat(item.selectedPriceType.price);
          }

          item.total = itemSumm.toFixed(2);
            
          totalSumm = totalSumm + itemSumm;
        }

        car.summ = totalSumm.toFixed(2);
        car.total = totalSumm.toFixed(2);
      }

      // Добавить услугу за неполную загрузку машины, если есть
      this.checkAddServiceCar()
    },

    checkAddServiceCar() {
      let carsArrayToService = []

      for (let car of this.objectNewOrder.cars) {
        let totalOccupancyRate = this.allRelatedOrders
          .filter(order => car.relatedOrders.includes(order.id))  // Фильтруем заказы
          .reduce((total, order) => total + parseInt(order.occupancyRate || 0), 0);  // Суммируем occupancyRate

        let totalSummOccupancyRate = totalOccupancyRate + parseInt(car.occupancyRate || 0)

        if (totalSummOccupancyRate < 100) {
          carsArrayToService.push(car.carId)
        }
      }

      // Добавление услуги
      // Выбираем нужную услугу из всех получееных, выполняем действия, если эта услуга есть в списке
      let service = this.orderServices.find(service => service.title == "Доплата за неполную загрузку машины");
      
      if (!service) {
        return;
      }

      if (carsArrayToService.length === 0) {
        this.selectedServices = this.selectedServices.filter(id => id != service.id)

        this.objectNewOrder.services = this.objectNewOrder.services.filter(
          item => item.id != service.id
        )

        this.selectedCarsServiceWithObj = this.selectedCarsServiceWithObj.filter(
          item => item.serviceId != service.id
        )

        return;
      }

      if (!this.selectedServices.includes(service.id)) {
        this.selectedServices.push(service.id)
      }

      let currentService = this.objectNewOrder.services.find(item => item.id == service.id)

      if (!currentService) {
        currentService = JSON.parse(JSON.stringify(service))
        currentService.cars = []
        this.objectNewOrder.services.push(currentService)
      }

      currentService.cars = carsArrayToService.map(carId => ({
        id: carId
      }))

      let selectedServiceCars = this.selectedCarsServiceWithObj.find(
        item => item.serviceId == service.id
      )

      if (selectedServiceCars) {
        selectedServiceCars.carsId = [...carsArrayToService]
      } else {
        this.selectedCarsServiceWithObj.push({
          serviceId: service.id,
          carsId: [...carsArrayToService]
        })
      }
    },

    formatDate(data) {
      let initialDate = new Date(data);
      let day = ("0" + initialDate.getDate()).slice(-2);
      let month = ("0" + (initialDate.getMonth() + 1)).slice(-2);
      let year = initialDate.getFullYear();

      return `${day}.${month}.${year}`
    },

    timezoneDate() {
      const date = new Date();

      // Получаем текущие компоненты даты
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Месяцы начинаются с 0
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      // Получаем смещение в минутах от UTC
      const timezoneOffsetInMinutes = date.getTimezoneOffset();
      const absOffset = Math.abs(timezoneOffsetInMinutes);
      const offsetHours = String(Math.floor(absOffset / 60)).padStart(2, '0');
      const offsetMinutes = String(absOffset % 60).padStart(2, '0');
      const sign = timezoneOffsetInMinutes > 0 ? '-' : '+';
      
      // Форматируем смещение
      const timezoneOffset = `${sign}${offsetHours}:${offsetMinutes}`;

      // Форматируем дату в нужный формат
      const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${timezoneOffset}`;

      return formattedDate;
    },

    addinfo() {
      this.objectNewOrder.modified = this.formatDate(new Date())
      // дата создания
      this.objectNewOrder.created = this.objectOrderDraft.creationDate
    },

    getCarShipmentDate(car) {
      let carDate = null
      if(!this.isEmpty(car.shipmentDate)) {
        let dateShipment = car.shipmentDate
        carDate = this.formatDate(dateShipment)
      }
      return carDate
    },

    // Вывод ошибок при сохранении заказа
    checkErrors(type) {
      // Флаг наличия ошибок в машинах с товарами
      let carsHaveError = false
      let textCarsError = ""

      outerLoop: // Метка для выхода из обоих циклов
      for (let car of this.objectNewOrder.cars) {
        // Если хоть в одной машине нет товаров
        if(type == "postOrder" && car.items.length == 0) {
          textCarsError = "Заполните товары во всех машинах"
          break outerLoop;
        }

        // Если хоть в одной машине не заполнена дата отгрузки
        if(type == "postOrder" && this.isEmpty(car.shipmentDate)) {
          textCarsError = "Заполните желаемую дату отгрузки во всех машинах"
          break outerLoop;
        }
        
        if(car.items.length > 0) {
          for (let item of car.items) {
            if(this.isEmpty(item.selectedPriceType)) {
              // Проверка выбора типа цены
              textCarsError = "Заполните виды цен на все товары"
              break outerLoop;
            }
          }
        }
      }

      if(!this.isEmpty(textCarsError)) {
        carsHaveError = true // ошибки в машинах есть
      }

      if(carsHaveError) this.errorText = textCarsError
      else if(this.isEmpty(this.objectNewOrder.contrAgent)) this.errorText = "Заполните контрагента"
      else if(this.isEmpty(this.objectNewOrder.orderNumberClient)) this.errorText = "Заполните номер заказа клиента"
      else if(this.isEmpty(this.objectNewOrder.division)) this.errorText = "Заполните тип продукции"
      else if(this.isEmpty(this.objectNewOrder.shipmentMethod)) this.errorText = "Заполните способ доставки"

      else if(
        (type == "postOrder" && this.isEmpty(this.selectedAddress) && this.objectNewOrder.shipmentMethod == "Доставка") || 
        (type == "postOrder" && this.objectNewOrder.shipmentMethod == "Доставка" && (this.selectedAddress != this.objectNewOrder.shipmentAddress )) || 
        (type == "saveOrder" && this.objectNewOrder.shipmentMethod == "Доставка" && (this.selectedAddress != this.objectNewOrder.shipmentAddress ))
      ) {
        this.errorText = "Выберите адрес доставки из предложенных вариантов или заполните форму"
        this.incorrectAddress= true;
      }

      else if(type == "postOrder" && this.isEmpty(this.objectNewOrder.consignee)) this.errorText = "Заполните грузополучателя"
      else if(type == "postOrder" && this.isEmpty(this.objectNewOrder.inn)) this.errorText = "Заполните ИНН"
      else if(!this.isEmpty(this.objectNewOrder.inn)) {
        if(this.objectNewOrder.inn.length < 10 || this.objectNewOrder.inn.length == 11) {
          this.errorText = "Некорректный ИНН. Для юридического лица - 10 цифр, для ИП - 12 цифр"
          this.incorrectInn = true;
        } else {
          this.errorText = ""
          this.incorrectInn = false;
        }
      }
      else {
        this.errorText = ""
        this.incorrectInn = false;
        this.incorrectAddress= false;
      }
    },

    // Объект для сохранения заказа
    getObjForSave() {
      let objForRequest = {}
        objForRequest.status = this.objectNewOrder.status
        objForRequest.created = this.timezoneDate()
        objForRequest.modified = this.timezoneDate()

        if(this.isEmpty(this.objectNewOrder.region_id)) {
          objForRequest.region_id = null
        } else {
          objForRequest.region_id = this.objectNewOrder.region_id
        }

        objForRequest.order_number_client = this.objectNewOrder.orderNumberClient
        objForRequest.company_id = this.objectNewOrder.contrAgent.id  
        objForRequest.shipment_method = this.objectNewOrder.shipmentMethod
        objForRequest.shipment_address = this.objectNewOrder.shipmentAddress
        objForRequest.add_information = this.objectNewOrder.addInformation
        objForRequest.division = this.objectNewOrder.division

        objForRequest.consignee = this.objectNewOrder.consignee
        objForRequest.inn = this.objectNewOrder.inn

        objForRequest.user = this.currUserID
        
        if(!this.currUserID) this.errorText = "Не получен ID пользователя"
        else this.errorText = ""

        

        let objCars = []
        // Заполнить машины
        for (let car of this.objectNewOrder.cars) {
          let objCar = {}
          // if(!this.isEmpty(this.idGetOrder)) objForRequest.id = this.objectNewOrder.id
          // obj.order_id = .. id заказа переехал
          objCar.car_id = car.carId // id машины
          // objCar.shipment_date = car.shipmentDate // дата отгрузки
          objCar.shipment_date = this.getCarShipmentDate(car) // дата отгрузки
          objCar.related_orders = car.relatedOrders // связанные заказы

          if(car.items.length < 1) {
            objCar.total = null
            objCar.order_weight = null
          } else {
            objCar.total = car.total // Сумма стоимости товаров
            objCar.order_weight = car.orderWeight // Сумма стоимости товаров
          }
          
          // Загрузка машины
          if(car.occupancyRate == 0 || this.isEmpty(car.occupancyRate)) {
            objCar.occupancy_rate = null
          } else {
            objCar.occupancy_rate = (car.occupancyRate).toString()
          }

          let itemsArr = []
          for (let item of car.items) {
            let objItem = {}

            if(!this.isEmpty(this.idGetOrder)) {
              objItem.id = item.originId
              objItem.item_id = item.id
            }

            objItem.item_id = item.id
            objItem.price_type_title = item.priceTypeTitle
            objItem.item_price = item.itemPrice
            objItem.price_type = item.priceType
            objItem.quantity = item.quantity
            objItem.total = item.total
            // total_and_service
            // objItem.total_and_service = "1"
            objItem.proposal_id = item.proposalId
            itemsArr.push(objItem)
          }
          objCar.items = itemsArr // массив с товарами
          objCars.push(objCar)
        }
        objForRequest.cars = objCars

        // Заполнить услуги
        let newServicesFormat = this.objectNewOrder.services.flatMap(service => 
          service.cars.map(car => ({
            id: service.id,
            car_id: car.id
          }))
        );

        objForRequest.services = newServicesFormat

        return objForRequest 
    },

    // Провека загрузки машин < 100%
    checkErrorsOccupancyRate() {
      let carErrorOccupancyRate = false
      
      // проверяем загрузку только для доставки
      if(this.objectNewOrder.shipmentMethod != 'Самовывоз') {
        for(let car of this.objectNewOrder.cars) {
          let totalOccupancyRate = this.allRelatedOrders
          .filter(order => car.relatedOrders.includes(order.id))  // Фильтруем заказы
          .reduce((total, order) => total + order.occupancyRate, 0);  // Суммируем occupancyRate

          let totalSummOccupancyRate = totalOccupancyRate + parseInt(car.occupancyRate)

          if(totalSummOccupancyRate > 100) { 
            carErrorOccupancyRate = car.carId
            break;
          }

        }
      }

      return carErrorOccupancyRate
    },

    async saveOrder() { // рассчет шапки
      this.addinfo() 

      // Проверить заказ на ошибки
      this.checkErrors("saveOrder")
      
      if(this.errorText == "") {
        this.loadSaveOrder = true
        this.calculateOrder()

        // Получаем id машины с ошибкой загрузки > 100%
        let errorCar = this.checkErrorsOccupancyRate()

        // Если загрузка всех машин <= 100%, то отправляем на сохранение, иначе ошибка
        if(!errorCar) {

          if(this.haveNewAddress) {
            let newAddStr = "Адрес не проверен: [" + this.objectNewOrder.shipmentAddress + "]"
            this.objectNewOrder.shipmentAddress = newAddStr
            this.selectedAddress = newAddStr
          }

          // статус
          this.objectNewOrder.status = this.objectOrderDraft.orderStatus
          
          let res = await GlobalRequest.request("/order/save/draft", "POST", this.getObjForSave())
          if(!res.success) {
            console.log(res)
            this.errorText = "Заказ не был сохранен"
            this.successText = ""
          }
          else {
            this.errorText = ""
            this.successText = "Заказ успешно сохранен"
            this.$router.push({
                path: '/orders',
            });
          }
        } else {
          this.$refs.confirmModal.open(
            () => {},
            "Машина №" + errorCar + " загружена более 100%.<br>Необходимо добавить машину и<br>перенести в нее часть товаров."
          );
        }

        this.loadSaveOrder = false
      }
    },

    cancelOrder() {
      this.$router.push({
          path: '/orders'
      });
    },

    async postOrder() { // рассчет шапки
      this.addinfo()
      this.checkErrors("postOrder")

      if(this.errorText == "") {
        this.loadPostOrder = true
        this.calculateOrder()
        
        // Получаем id машины с ошибкой загрузки > 100%
        let errorCar = this.checkErrorsOccupancyRate()

        // Если загрузка всех машин <= 100%, то отправляем на сохранение, иначе ошибка
        if(!errorCar) {

          if(this.haveNewAddress) {
            let newAddStr = "Адрес не проверен: [" + this.objectNewOrder.shipmentAddress + "]"
            this.objectNewOrder.shipmentAddress = newAddStr
            this.selectedAddress = newAddStr
          }

          // статус
          let objForRequest = this.getObjForSave()
          objForRequest.status = "На согласовании (Поставщик)"
          
          let res = await GlobalRequest.request("/order/save", "POST", objForRequest)
          if(!res.success) {
            this.errorText = "Заказ не был размещен"
            this.successText = ""
          }
          else {
            this.objectNewOrder.status = "На согласовании (Поставщик)"
            this.errorText = ""
            this.successText = "Заказ успешно размещен"
            this.$router.push({
              path: '/orders',
                // path: '/order/detail',
                // query: { id: res.data.orderId, type: 'view' },
            });
          }
          
        } else {
          this.$refs.confirmModal.open(
            () => {},
            "Машина №" + errorCar + " загружена более 100%.<br>Необходимо добавить машину и<br>перенести в нее часть товаров."
          );
        }

        this.loadPostOrder = false
      }
      
    },

    addShipmentAddress(address) {
      this.selectedAddress = address
      this.haveNewAddress = false
    },

    saveAddress(newAddressArray) {
      let addressStr = ""
      if(newAddressArray) {
        newAddressArray.forEach(field => {
          if(!this.isEmpty(field))
            addressStr += field + ", "
        });

        // Удаляем последнюю запятую и пробел
        addressStr = addressStr.slice(0, -2);

        this.objectNewOrder.shipmentAddress = addressStr
        this.selectedAddress = addressStr

        this.showFormAddAddress = false
        this.haveNewAddress = true
      }

    },

    showFormAddAddressMethod() {
      this.showFormAddAddress = true
    },

    haveNewAddressFalse() {
      this.haveNewAddress = false
    },

    editShipmentAddress(newVal) {
      this.objectNewOrder.shipmentAddress = newVal
    },

    async getRelatedOrders(regionId) {
      let res = await GlobalRequest.request("/order/list/related?regionId=" + regionId, "GET")
      console.log("Связанные заказы")
      console.log(res)

      let nextRelatedOrders = []

      if(res.success) {
        for(let order of res.data) {
          let obj = {}
          obj.id = order.id
          obj.name = order.orderNumberClient + " " + parseInt(order.occupancyRate) + "%"
          obj.occupancyRate = parseInt(order.occupancyRate)
          obj.shipmentDate = order.shipmentDate
          obj.carId = 0
          nextRelatedOrders.push(obj)
        }
      }

      if (JSON.stringify(this.allRelatedOrders) === JSON.stringify(nextRelatedOrders)) {
        return;
      }

      this.allRelatedOrders = nextRelatedOrders
      this.originAllRelatedOrders = JSON.parse(JSON.stringify(this.allRelatedOrders))
    },

    addOrderCar() {
      // Находим максимальное значение carId в существующих объектах
      const maxId = this.objectNewOrder.cars.reduce((max, car) => {
        return car.carId > max ? car.carId : max;
      }, 0);

      let newCar = {
        carId: maxId + 1,
        shipmentDate: null,
        relatedOrders: [],
        summ: 0,
        orderWeight: 0,
        occupancyRate: 0,
        items: []
      }

      this.objectNewOrder.cars.push(newCar);
    },

    // Удалить машину
    delCar(carId) {
      let carItems = this.objectNewOrder.cars.find(car => car.carId == carId).items;
      if(carItems.length > 0) {
        this.$refs.confirmModal.open(
          () => {
            this.removeCar(carId);
            this.updateCarIds(); // Обновляем нумерацию после удаления
            this.updateSelectedServiceCars()
          },
          "Вы действительно хотите удалить машину с товарами №" + carId + " ?" 
        );
      } else {
        this.removeCar(carId)
        this.updateCarIds(); // Обновляем нумерацию после удаления
        this.updateSelectedServiceCars()
      }
    },
    removeCar(carId) {
      this.objectNewOrder.cars = this.objectNewOrder.cars.filter(car => car.carId !== carId);
      
      // Обновить принадлежность связанных заказов
      for (let order of this.allRelatedOrders) {
        if(order.carId == carId) {
          order.carId = 0
        }
      }

    },

    updateCarIds() {
      // Обновляем id автомобилей, чтобы они были последовательными
      this.objectNewOrder.cars.forEach((car, index) => {
        car.carId = index + 1; 
      });

      this.selectedItems.forEach((obj, index) => {
        obj.carId = index + 1; 
      });
    },

    updateSelectedServiceCars() {
      // Все услуги чистим
      this.objectNewOrder.services.forEach(service => {
        service.cars = []
      });

      this.selectedCarsServiceWithObj = []
    },

    handleItemsRemoveChange(carId, itemId) {
      // Инициализируем массив для машины, если он еще не существует
      if (!this.selectedItemsDel[carId]) {
        this.selectedItemsDel[carId] = [];
      }

      const index = this.selectedItemsDel[carId].indexOf(itemId);

      // Добавляем или удаляем элемент из выбранных
      if (index === -1) {
        this.selectedItemsDel[carId].push(itemId);
      } else {
        this.selectedItemsDel[carId].splice(index, 1);
      }
    },

    // Метод для проверки, выбран ли элемент
    isSelectedRemoveItem(carId, itemId) {
      return this.selectedItemsDel[carId]?.includes(itemId) || false;
    },

    selectedRelatedOrders(carId, selectedElements) {
      const selectedArray = Array.isArray(selectedElements) ? selectedElements : [];

      const relatedOrderIds = selectedArray
        .filter(item => item && item.id !== undefined && item.id !== null)
        .map(item => item.id)
        .filter((id, index, array) =>
          array.findIndex(itemId => String(itemId) === String(id)) === index
        );

      const car = this.objectNewOrder.cars.find(car => car.carId === carId);

      if (!car) {
        return;
      }

      const currentIds = Array.isArray(car.relatedOrders) ? car.relatedOrders : [];

      const isSame =
        currentIds.length === relatedOrderIds.length &&
        currentIds.every(id => relatedOrderIds.some(newId => String(newId) === String(id)));

      if (isSame) {
        return;
      }

      car.relatedOrders = relatedOrderIds;

      for (let order of this.allRelatedOrders) {
        if (relatedOrderIds.some(id => String(id) === String(order.id))) {
          order.carId = carId; // Если id есть в relatedOrderIds, устанавливаем carId
        } else if (order.carId == carId) {
          order.carId = 0; // Если id нет в relatedOrderIds, устанавливаем carId в 0
        }
      }
    },

    // Отслупы по тысячным в числах
    formatNumber(numberText) {
      if(numberText) {
        return numberText.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      } 
    },

    updateNewAddressArrayForm(val) {
      this.newAddressArrayForm = val
    },

    getCarItems(list, carId) {
      const rec = list.find(x => x.carId == carId);
      return rec?.items ?? [];
    },

    generateRowId() {
      return (
        Date.now().toString(36) +
        Math.random().toString(36).substr(2, 9)
      );
    },
    
  }
}
</script>